import { SpinBannerForm } from './form';

import { SpinBannerSettingsModel, SpinBannerSettingsRequest } from 'v2/types/SpinBannerSettingsModel';

export const DESCRIPTION_MAX_LENGTH = 184;

export const stripHtmlTags = (value: string): string => value.replace(/<[^>]*>/g, '');

const BLOCK_TAG_REGEXP = /<(p|div|h[1-6]|li|blockquote)(?:\s[^>]*)?>([\s\S]*?)<\/\1>/gi;
const LINE_BREAK_REGEXP = /<br\s*\/?>/gi;

const getRichTextBlockText = (value: string): string => {
  const text = stripHtmlTags(value.replace(LINE_BREAK_REGEXP, '\n'));

  return /^\s*\n\s*$/.test(text) ? '' : text;
};

export const getRichTextTextLength = (value: string): number => {
  const normalizedValue = value.replace(/\r\n?/g, '\n');
  const blocks = [...normalizedValue.matchAll(BLOCK_TAG_REGEXP)];

  if (blocks.length === 0) {
    return getRichTextBlockText(normalizedValue).length;
  }

  return blocks.map((block) => getRichTextBlockText(block[2])).join('\n').length;
};

/** True when the editor looks empty (e.g. Quill leaves `<p><br></p>`). */
export const isRichTextEffectivelyEmpty = (value: string | undefined | null): boolean => {
  const plain = stripHtmlTags(value ?? '')
    .replace(/ /g, ' ')
    .trim();

  return plain.length === 0;
};

export const getFormValuesFromModel = (model: SpinBannerSettingsModel): SpinBannerForm => ({
  description: model.description ?? '',
  casinoName: model.casinoName ?? '',
  casinoButtonLink: model.casinoButtonLink ?? '',
  casinoButtonText: model.casinoButtonText ?? '',
  promocodeRewardDescription: model.promocodeRewardDescription ?? '',
  logoId: model.logoId ?? '',
  topLabelText: model.topLabelText ?? '',
  badgeText: model.badgeText ?? '',
});

export const getRequestFromForm = (values: SpinBannerForm): SpinBannerSettingsRequest => ({
  description: values.description,
  casinoName: values.casinoName,
  casinoButtonLink: values.casinoButtonLink,
  casinoButtonText: values.casinoButtonText,
  promocodeRewardDescription: values.promocodeRewardDescription,
  logoId: values.logoId,
  topLabelText: values.topLabelText ?? '',
  badgeText: values.badgeText ?? '',
});
